module.exports = __webpack_public_path__ + "img/logo-n.45be8f1e.svg";